import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {navigationIcArrowDownward24px, navigationIcArrowUpward24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {applyRound} from '@ey/utils';
import {isNullOrUndefined, labels, getPriorPeriodChange} from '../../../../util/utils';
import {getAccountById} from '../../../../selectors/Ares/selectors';
import {getInUserNumberFormat} from './AccountSummaryConfig';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import Tooltip from '../../BaseComponentWrappers/MotifTooltip';
import Icon from '../../BaseComponentWrappers/MotifIcon';

function PriorPeriod({className, accountId, styleName}) {
	const {priorBalance, currentBalance} = useSelector((state) => getAccountById(state, accountId)) || {};

	const priorPeriodChange = getPriorPeriodChange(priorBalance, currentBalance);

	const getPriorPeriodTrend = (priorPeriodChange) => {
		if (priorPeriodChange === null || priorPeriodChange === 0) {
			return <span className="motif-icon motifIconEmpty" />;
		} else {
			return priorPeriodChange > 0 ? (
				<Icon className="priorperiod-green-arrow" src={navigationIcArrowUpward24px} />
			) : (
				<Icon className="priorperiod-red-arrow" src={navigationIcArrowDownward24px} />
			);
		}
	};
	return (
		<StyledSection className={`${className} ${styleName} ${isNullOrUndefined(priorBalance) ? 'nullundefined' : ''}`}>
			<span className="prior-balance">
				<Tooltip
					closeButtonProps={{
						className: 'hide'
					}}
					allowClick={false}
					placement="top"
					className={'priorperiod-tooltip'}
					variant="alt"
					trigger={
						isNullOrUndefined(priorPeriodChange) ? (
							<span className="priorperiod-tooltiplabel">
								<EllipsesControl noOfLines={1} content={labels.notapplicable} tooltip={labels.notapplicable} />
							</span>
						) : (
							<span className="priorperiod-tooltiplabel">{applyRound(priorPeriodChange, 1) + '%'}</span>
						)
					}
					hide={priorPeriodChange === null}
					children={
						<>
							<span>{labels.prioryearbalance}</span>
							{'  '}
							<span>
								{!isNullOrUndefined(priorBalance) ? getInUserNumberFormat(priorBalance) : labels.notapplicable}
							</span>
						</>
					}
				/>
				{'  '} {getPriorPeriodTrend(priorPeriodChange)}
			</span>
		</StyledSection>
	);
}

PriorPeriod.propTypes = {
	className: PropTypes.string,
	accountId: PropTypes.number.isRequired
};

PriorPeriod.defaultProps = {
	className: 'priorperiod-cellrenderer'
};

export default PriorPeriod;

const StyledSection = styled.section`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	font-weight: 300;
	font-size: var(--px-14);
	line-height: var(--px-22);
	padding-right: var(--px-5);
	&.nullundefined {
		.prior-balance {
			.priorperiod-tooltiplabel {
				.ellipses {
					justify-content: flex-end;
				}
			}
		}
	}
	.prior-balance {
		display: inline-flex;
		justify-content: flex-end;
		align-items: center;
		width: 100%;
		text-align: right;
		.motif-icon {
			margin: 0 0 0 var(--px-5);
			display: inline-flex;
			width: var(--px-16);
			justify-content: left;
			&.priorperiod-red-arrow {
				svg {
					fill: var(--red-400);
					path {
						fill: var(--red-400);
					}
				}
			}
			&.priorperiod-green-arrow {
				svg {
					fill: var(--green-300);
					path {
						fill: var(--green-300);
					}
				}
			}
			svg {
				height: var(--px-20) !important;
				width: var(--px-20) !important;
				vertical-align: middle;
			}
		}
		.motif-tooltip-wrapper {
			display: inline-flex;
			max-width: 85%;
			min-width: 20%;
			justify-content: flex-end;
			.motif-tooltip-trigger-wrap {
				width: 100%;
			}
			.priorperiod-tooltiplabel {
				cursor: pointer;
				display: block;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 100%;
			}
		}
	}
`;
